import React from "react";

const VATInvoice = ({subscription, taxMeta, countryCode}) => {
    const taxRate = Number(subscription?.taxRateApplied || 5);
    const gross = Number(subscription?.baseAmount || 0);
    const tax = (gross * taxRate) / 100;
    const total = gross + tax;

    return (
        <div className="text-white"> 
            <div className="text-lg font-bold text-cyan-400">
                DISTRIBUTOR VAT INVOICE
            </div>
            <div className="text-xs text-gray-400">
                {countryCode} Tax Invoice
            </div>
            <div className="border-t border-gray-700 mt-4 pt-4">
                <div className="text-sm font-semibold text-cyan-300">
                    Customer
                </div>
                <div className="text-xs mt-2">
                    {subscription.userName}
                </div>
                <div className="text-xs">
                    {subscription.userCode}
                </div>
            </div>

            <div className="border-t border-gray-700 mt-4 pt-4">
                <div className="grid grid-cols-2 gap-2 text-xs">
                    <div>Invoice No</div>
                    <div className="text-right">
                        {subscription.invoiceNumber}
                    </div>
                    <div>Subscription</div>
                    <div className="text-right">
                        {subscription.product}
                    </div>
                    <div>Net Amount</div>
                    <div className="text-right">
                        {subscription.currencySymbol}{" "}
                        {subscription.baseAmount.toFixed(2)}
                    </div>
                    <div>VAT {vatRate}%</div>
                    <div className="text-right">
                        {subscription.currencySymbol}{" "}
                        {(subscription.baseAmount * subscription.taxRateApplied).toFixed(2)}
                    </div>
                    <div className="font-bold">
                        Total
                    </div>
                    <div className="text-right font-bold text-green-400">
                        {subscription.currencySymbol}{" "}
                        {(subscription.finalAmount).toFixed(2)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VATInvoice;